import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../../../components";
import { discountTypeOptions } from "../../../../../../../assets/data/projectData";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { useDispatch } from "react-redux";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";

const Discounts = ({
  setActiveTab,
  currentPlacement,
  handleBack,
  editData,
}) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      discountName: "",
      discountType: "",
      discountValue: "",
    },
    {
      discountName: { type: "text", required: true },
      discountType: { type: "number", required: true },
      discountValue: { type: "text", required: true },
    },
  );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const userFormData = {
        name: formData.discountName,
        type: formData?.discountType,
        value: formData?.discountValue,
      };
      const uiid = fetchPerticularData?.uiid ?? "";
      const submissionData = filterEmptyValues(userFormData);
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: submissionData,
          rsn: "permanetPlacementDiscount",
          payload: [
            {
              type: "SET",
              value: {
                invoices: {
                  discount: { ...submissionData },
                },
              },
            },
          ],
          onSuccess: async (payload) => {
            handleBack();
          },
        }),
      );
    } else {
      console.log("form errors : ", errors);
    }
  };
  //   useEffect(()=>{
  // const permanetPlacementDiscount=currentPlacement?.permanetPlacementDiscount;
  // if(permanetPlacementDiscount){
  //   handleChange("discountName", permanetPlacementDiscount?.name)
  //   handleChange("discountType", permanetPlacementDiscount?.type)
  //   handleChange("discountValue", permanetPlacementDiscount?.value)
  // }
  //   },[currentPlacement])
  //   useEffect(()=>{
  //           const permanetPlacementDiscount=currentPlacement?.permanetPlacementDiscount||{};
  //          const isEmptyOrMissing =
  //           !permanetPlacementDiscount ||
  //           Object.keys(permanetPlacementDiscount).length === 0;
  //       const invoices=editData?.invoices||{};
  //         if (isEmptyOrMissing && isEditable) {
  //          handleChange("discountName",invoices?.discount?.name)
  //          handleChange("discountType",invoices?.discount?.type)
  //          handleChange("discountValue",invoices?.discount?.value?`${invoices?.discount?.value}`:"")
  //         }
  //         },[isEditable])
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "invoices.discount uiid",
            // ref: "InvDoc",
            // incl: "uiid businessName",
          },
        });
        const data = response?.data?.data;
        if (data) {
          const invoices = data?.invoices || {};
          setFetchPerticularData(data);
          handleChange("discountName", invoices?.discount?.name);
          handleChange("discountType", invoices?.discount?.type);
          handleChange(
            "discountValue",
            invoices?.discount?.value ? `${invoices?.discount?.value}` : "",
          );
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };
    fetchData();
  }, [currentPlacement, isEditable]);
  return (
    // <div className="px-8 py-5 overflow-auto min-h-[60vh]">
    <div className="px-8 py-5 overflow-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl">
        <div>
          <FormFieldSet
            type="text"
            title={"Discount Name"}
            placeholder="Enter Discount Name"
            value={formData.discountName}
            onChange={(value) => handleChange("discountName", value)}
            error={errors.discountName}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Discount Type"}
            placeholder="Enter Discount Type"
            value={formData.discountType}
            onChange={(value) => handleChange("discountType", value)}
            error={errors.discountType}
            options={discountTypeOptions}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Discount Value"}
            placeholder="Enter Discount Value"
            value={formData.discountValue}
            onChange={(value) => handleChange("discountValue", value)}
            error={errors.discountValue}
          />
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-6">
        <Button title={"Cancel"} variant="outlined" />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default Discounts;
